class ContactForm {
  constructor(endpoint, key) {
    this.endpoint = endpoint;
    this.localStorageKey = key;

    this.cacheDOMElements();
    this.bindEvents();
    this.checkURLHash();
    this.isSent();
  }

  cacheDOMElements() {
    this.form = document.querySelector("#contactForm");
    this.submitBtn = document.querySelector(`#contact-submit-btn`);
    this.loadingSpinner = document.querySelector(`#loading-spinner`);
    this.thankYouMessage = document.querySelector(`#thankYouMessage`);
    this.contactFormContainer = document.querySelector(`#contactFormPopup`);
    this.thankCloseIcon = document.querySelector("#thank-close-icon");
    this.thankCloseBtn = document.querySelector("#thank-close-btn");
    this.contactCloseIcon = document.querySelector("#contact-form-close-icon");
    
    this.popups = document.querySelectorAll('.contact__form__popup')

    this.contactResHeader = document.querySelector(
      "#contact-form-response-header"
    );
    this.contactResMessage = document.querySelector(
      "#contact-form-response-message"
    );

    this.openTriggers = document.querySelectorAll(".open-contact-form");

    if (
      !this.form ||
      !this.submitBtn ||
      !this.loadingSpinner ||
      !this.thankYouMessage ||
      !this.openTriggers.length
    ) {
      console.error("One or more elements not found in the DOM");
      return;
    }
  }

  bindEvents() {
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showContactForm = this.showContactForm.bind(this);
    this.closeContactForm = this.closeContactForm.bind(this);
    this.closeThankYouMessage = this.closeThankYouMessage.bind(this);

    this.form.addEventListener("submit", this.handleSubmit);
    
    this.popups.forEach((popup)=>{
      popup.addEventListener('click', (e)=>{
       if(e.target.classList.contains('contact__form__popup')){
        this.closeContactForm();
        this.closeThankYouMessage()
       }

      })
    })

    this.openTriggers.forEach((trigger) =>
      trigger.addEventListener("click", this.showContactForm)
    );

    this.thankCloseIcon.addEventListener("click", this.closeThankYouMessage);
    this.thankCloseBtn.addEventListener("click", this.closeThankYouMessage);
    this.contactCloseIcon.addEventListener("click", this.closeContactForm);
  }

  isSent() {
    if (localStorage.getItem(this.localStorageKey) === "submitted") {
      return true;
    }
    return false;
  }

  checkURLHash() {
    if (window.location.hash === "#contact") {
      console.log(this.isSent())
      if (this.isSent()) {
        this.displayThankYou(true, "success");
      } else {
        console.log('this triggers')
        this.showContactForm(new Event("click"));
      }
    }
  }

  displayLoading(show) {
    this.loadingSpinner.style.display = show ? "block" : "none";
    this.submitBtn.disabled = show;
  }

  closeContactForm() {
    this.contactFormContainer.style.display = "none";
  }

  closeThankYouMessage() {
    this.thankYouMessage.style.display = "none";
  }

  displayThankYou(show, type) {
    console.log('this runs')
    this.thankYouMessage.style.display = show ? "block" : "none";
    if (type === "success") {
      this.contactResHeader.innerHTML = "Thank you!";
      this.contactResMessage.innerHTML =
        "Thank you, we will contact you shortly.";
    } else {
      this.contactResHeader.innerHTML = "Error";
      this.contactResMessage.innerHTML =
        "An error occurred, please contact us via email, chat or phone.";
    }
    this.contactFormContainer.style.display = show ? "none" : "block";
  }

  showContactForm(e) {
    e.preventDefault();
    if(this.isSent()){
      this.displayThankYou(true, "success");
    }else {
      this.contactFormContainer.style.display = "block";
    }

  }

  async handleSubmit(e) {
    e.preventDefault();
    this.displayLoading(true);

    // Simulate API call
    try {
      const formData = new FormData(this.form);
      let jsonObject = {};
      formData.forEach((value, key) => {
        jsonObject[key] = value;
      });
      if(window?.contactFormPayload){
        jsonObject = {
          ...jsonObject,
          ...window.contactFormPayload
        }
      }
      const response = await fetch(this.endpoint, {
        method: "POST",
        body: JSON.stringify(jsonObject),
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        localStorage.setItem(this.localStorageKey, "submitted");
        this.displayThankYou(true, "success");
      } else {
        // Handle error
        this.displayThankYou(true, "failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      this.displayThankYou(true, "failed");
    } finally {
      this.displayLoading(false);
    }
  }
}
